var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 12.25,
    r: 8.25,
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 12.25,
    r: 8.25,
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4265 4.08325C13.3493 4.12994 13.2728 4.17778 13.1971 4.22674C14.0624 5.03217 14.8012 5.97173 15.3804 7.01233C16.0877 6.68437 16.7349 6.24871 17.3009 5.72641C17.7243 6.05473 18.1149 6.42338 18.467 6.82658C17.7615 7.49369 16.9488 8.04852 16.0574 8.46249C16.5371 9.7163 16.8 11.0774 16.8 12.5C16.8 13.7625 16.5929 14.9767 16.2109 16.1105C17.0423 16.5158 17.8023 17.0447 18.467 17.6734C18.115 18.0766 17.7244 18.4452 17.3009 18.7735C16.7917 18.3037 16.2169 17.9039 15.5916 17.5896C15.0681 18.6255 14.3899 19.5698 13.5872 20.3922C13.152 20.4631 12.7053 20.5 12.25 20.5C11.5113 20.5 10.7953 20.4029 10.114 20.2208C9.47278 19.5033 8.9202 18.6987 8.47393 17.8264C8.0152 18.0967 7.58796 18.4147 7.19904 18.7736C6.7756 18.4452 6.38498 18.0766 6.03296 17.6734C6.57666 17.1592 7.18408 16.7118 7.84214 16.3441C7.42632 15.1422 7.2 13.8472 7.2 12.5C7.2 10.9957 7.48216 9.55658 7.9952 8.23942C7.27811 7.85673 6.6186 7.38033 6.033 6.82657C6.38503 6.42337 6.77565 6.05472 7.19909 5.72639C7.64547 6.1383 8.14233 6.49631 8.67933 6.79012C9.20578 5.85083 9.85834 4.99726 10.6134 4.25561C10.5756 4.23217 10.5378 4.20898 10.4997 4.18604C11.0638 4.06417 11.6494 4 12.25 4C12.6494 4 13.0422 4.02838 13.4265 4.08325ZM11.9158 5.22467C12.6675 5.88806 13.3156 6.66613 13.8327 7.5315C13.3226 7.64184 12.7931 7.69995 12.25 7.69995C11.5275 7.69995 10.8291 7.59712 10.1685 7.40529C10.6473 6.58949 11.2375 5.85502 11.9158 5.22467ZM12.25 9.29995C11.279 9.29995 10.3438 9.14704 9.46698 8.86398C9.03717 9.98458 8.8 11.2112 8.8 12.5C8.8 13.6194 8.97896 14.692 9.30769 15.689C10.2302 15.372 11.22 15.2 12.25 15.2C13.1042 15.2 13.9308 15.3183 14.7142 15.5395C15.0294 14.5834 15.2 13.5616 15.2 12.5C15.2 11.2677 14.9702 10.0892 14.5512 9.00478C13.8164 9.19739 13.0452 9.29995 12.25 9.29995ZM12.25 16.7999C12.8818 16.7999 13.4953 16.8786 14.0812 17.0267C13.5296 18.0701 12.7933 19.0008 11.9158 19.7752C11.1211 19.0367 10.4474 18.1553 9.93204 17.1676C10.6616 16.929 11.4407 16.7999 12.25 16.7999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H20",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/country.45f24a18cc6cdd9ed7addc6e465197e8.svg";
export { ForwardRef as ReactComponent };